import React from 'react';
import { motion } from 'framer-motion';

const AboutSection = ({ title, content, image, imageAlt, textPosition = 'left',bgColor = 'bg-transparent' }) => {
  return (
    <section className="relative py-16 bg-transparent">
      {/* Wood texture background */}
      {/* <div 
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{ backgroundImage: 'url("/assets/woodlogs.jpg")' }}
      /> */}
      {/* Dark overlay for better contrast */}
      {/* <div className="absolute inset-0 bg-black/30 z-0" /> */}
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="order-2 lg:order-1 rounded-[2rem] p-8 bg-white/10 backdrop-blur-md border border-white/20 shadow-lg"
            // style={glassStyles.dynamic.initial}
            // whileHover={glassStyles.dynamic.hover}
          >
            <h2 className="text-3xl md:text-4xl font-cursive text-akasha-brown mb-4 md:mb-6">
              {title}
            </h2>
            <div className="text-base md:text-lg text-akasha-black space-y-4">
              {content}
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="order-1 lg:order-2"
          >
            <motion.div 
              className="relative w-full rounded-[2rem] overflow-hidden shadow-xl"
              // Removed h-[400px] to allow natural height, kept w-full
            >
              <img
                src={image}
                alt={imageAlt}
                className="w-full h-auto object-cover block" // Added block, h-auto ensures aspect ratio is maintained
              />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
